import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectskalpataru } from "../../../../data/projects/kalpataru/data";
import { projectsrustomjee } from "../../../../data/projects/Rustomjee/data";

export const RustomjeePanorama = () => {
  const {
    thepanorama: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsrustomjee;

  return (
    <>
      <Helmet>
        <title>Rustomjee The Panorama, Pali Hill, Mumbai | Luxury Residences with City Views</title>

        <meta
          name="description"
          content="Discover Rustomjee The Panorama at Pali Hill, Mumbai – an exclusive luxury residential project offering premium apartments with world-class amenities and breathtaking city views."
        />

        <meta
          name="keywords"
          content="Rustomjee The Panorama, Pali Hill Mumbai, Rustomjee luxury apartments, Rustomjee Pali Hill, luxury residences Mumbai, Rustomjee The Panorama price, Rustomjee new project Mumbai, premium apartments Pali Hill"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/rustomjee-the-panorama-pali-hill-mumbai"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
